<template>
  <div class="content bg8">
    <div class="middled">
      <div class="basehero">
        <h1>
          Managed Employee Services
        </h1>
        <h2 class="section">
          Our Managed Internship Programs help you build and manage a team on <a href="/solution" class="pink">our solution.</a>
        </h2>
        
        <p>
          Hiring and managing employees is one of the most important skills you will develop.
          So we created a unique internship program to help you find, hire, and manage your first employees in one place.
          <strong>
            Connect with untapped early-career talent.
          </strong>
          Foclarity connects ambitious students with startups through managed intern programs across marketing, operations, and more—giving founders reliable help, and interns real-world learning.
        </p>
        <p>
          From social media to website design and more,
          everything is tailored to your specific needs and budget. 
          Choose from programs like:
          <ul class="pink-links">
            <li><router-link to="/digital-marketing-internship">Digital Marketing Internship Program</router-link></li>
            <li><router-link to="/social-media-marketing-internship">Social Media Marketing Internship Program</router-link></li>
            <li><router-link to="/content-creation-internship">Content Creation and Copywriting Internship Program</router-link></li>
            <li><router-link to="/website-design-internship">Website Design Internship Program</router-link></li>
            <li><router-link to="/data-analytics-internship">Data Analytics and BI Internship Program</router-link></li>
            <li><router-link to="/graphic-design-internship">Graphic Design Internship Program</router-link></li>
          </ul>
        </p>

        <div class="row" style="margin-top: 20px;">
          <div class="column">
            <h2>Why choose us to run your internship program?</h2>
            <ul class="bullets">
              <li>Affordable and flexible pricing plans</li>
              <li>Access to a team of experienced digital marketing professionals</li>
              <li>Customized strategies tailored to your business goals</li>
              <li>Real-time analytics and reporting to track your progress</li>
              <li>Ongoing support and consultation to ensure your success</li>
            </ul>
          </div>
        </div>

        <div class="panel max fullbluelt">
          <div class="row middled">
            <div class="column" style="justify-content:center;margin:auto;">
              <div style="padding:0px 20px;">
                <div class="marketline">
                  Founders ❤️ Foclarity
                </div>
                <h3 style="line-height:1.5em;">
                  &ldquo;Before Foclarity, we were swimming in an endless sea of great ideas and possibilities, 
                  but we had no anchor to tether them to. 
                  Foclarity worked with us to clarify our offerings, 
                  focus on strategic steps forward and ensure that our vision was aligned—both as an executive team and brand. 
                  The solution and people behind it have played a pivotal role in Vault's evolution. 
                  The team is experienced, insightful and genuinely dedicated to our success. 
                  Thank you for helping us find the focus and clarity we needed to succeed!&rdquo;
                </h3>
                <p>
                  Allison Beck<br>
                  Co-founder | Vault
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="basehero" style="">
        <h1 style="text-align: center;">Managed Intern Pricing</h1>
        <p style="text-align: center;">For the Digital Marketing Internship Program</p>
        <div class="row">
          <div class="column">
            <div style="padding:0 10px;background:#f0f8ff;border:4px solid #ccc;flex:1;">
              <h3 style="text-align:center" title="Basic Marketing Services">2 Interns</h3>
              <ul class="pricing-list">
                <li><a href="/pricing">Pro Subscription Included</a></li>
                <li>Social Media (2 channels)</li>
                <li>Email Creative (1 per month)</li>
                <li>Basic Content Creation</li>
                <li>Basic SEO / website updates</li>
                <li>Quarterly Strategy Session</li>
                <li>Monthly Marketing Meeting</li>
                <li>On-demand Analytics</li>
                <li>AI-enhanced Tasks</li>
                <li>Progress Tracking</li>
                <li>Visual Reporting</li>
              </ul>
              <p style="font-size:2rem;text-align:center">
                $500<br>
                <span style="font-size:.8rem;">per month</span>
              </p>
              <p style="text-align:center">
                <a href="https://buy.stripe.com/9B65kC6b276Ne6qbkS14400" target="_blank" rel="nofollow">
                  <button style="padding:10px 20px;"> Subscribe </button>
                </a>
              </p>
            </div>
          </div>
          <div class="column">
            <div style="padding:0 10px;background:#f0f8ff;border:4px solid #BF00FF;flex:1;">
              <h3 style="text-align:center" title="Collaborate with your team">4 Interns</h3>
              <ul class="pricing-list">
                <li><a href="/pricing">Pro Subscription Included</a></li>
                <li>Social Media (4 channels)</li>
                <li>Email Creative (2 per month)</li>
                <li>Advanced Content Creation</li>
                <li>Advanced SEO / website updates</li>
                <li>Monthly Strategy Session</li>
                <li>Weekly Marketing Meeting</li>
                <li>Monthly Analytics Report</li>
                <li>AI-enhanced Learning</li>
                <li>Advanced Tracking</li>
                <li>Advanced Reporting</li>
              </ul>
              <p style="font-size:2rem;text-align:center">
                $1,500<br>
                <span style="font-size:.8rem;">per month</span>
              </p>
              <p style="text-align:center">
                <a href="https://calendly.com/foclarity/30min" target="_blank" rel="nofollow">
                  <button style="padding:10px 20px;background: #BF00FF;"> Subscribe </button>
                </a>
              </p>
            </div>
          </div>
          <div class="column">
            <div style="padding:0 10px;background:#f0f8ff;border:4px solid #ccc;flex:1;">
              <h3 style="text-align:center">SMB +</h3>
              <ul class="pricing-list">
                <li><a href="/pricing">Pro Subscription Included</a></li>
                <li>Social Media / Paid Ad Management*</li>
                <li>Email Creative (4 per month)</li>
                <li>Advanced Content / Video Creation</li>
                <li>Podcast / Video Editing</li>
                <li>Quarterly Workshops</li>
                <li>Weekly Strategy Meeting</li>
                <li>Advanced Analytics</li>
                <li>AI Agent Programming</li>
                <li>Campaign Tracking</li>
                <li>Personalized Support</li>
              </ul>
              <p style="font-size:2rem;text-align:center">
                $5,000<br>
                <span style="font-size:.8rem;">per month</span>
              </p>
              <p style="text-align:center">
                <a href="https://buy.stripe.com/00w8wOdDu76NbYi1Ki14401" target="_blank" rel="nofollow">
                  <button style="padding:10px 20px;"> Subscribe </button>
                </a>
              </p>
            </div>
          </div>
        </div>
      
        <div class="centered">
            <h3>Just want to use our software?</h3>
            <p>Check out <a href="/pricing" class="pink">Subscription Pricing</a>.</p>
        </div>
        
      </div>      
    </div>    
  </div>
</template>

<script>
import { isLoggedIn } from "../utils/auth";

export default {
  title: 'Building Your Future Workforce | Foclarity',
  name: "WhoWeServe",
  mounted: function() {
    if (isLoggedIn()) {
      // this.$router.push("dashboards");
    }
  },
  methods: {
    isLoggedIn() {
      return isLoggedIn();
    }
  },
  data () {
      return {
      }
  },
  created () {
  }
};
</script>

<style lang="scss" scoped>

.heroblue {
  background: linear-gradient(110deg, #00b2ee 60%, #007cee 60%);
  height: 320px;
  margin: -20px -20px 20px -20px;
  border-radius: 4px 4px 0 0;
  @media only screen and (max-width: 440px) {
    border-radius: 0px 0px 0 0;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  & h1 {
    text-align: center;
    color: #fff;
    font-size: 45px;
    max-width: 600px;
    @media (max-width: 415px) {
      font-size: 36px;
      padding: 20px;
    }
  }
  & a {
    text-decoration: none;
    color: #fff;
    & .signupbox {
      text-align: center;
      padding: 8px;
      font-size: 24px;
      font-weight: bold;
      background: #ff7f24;
      width: 300px;
      border-radius: 10px;
      border: 1px solid #fff;
      margin: auto;
    }
  }
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  padding: 10px;
  min-width: 200px;
  & .homecard {
    text-align: center;
    padding: 20px;
    border-radius: 4px;
    background: rgba(0, 178, 238, 0.1);
    height: 100%;
    & .cardicon {
      width: 100px;
      height: 100px;
      margin: auto;
      & img {
        width: 80px;
      }
    }
    & .h34 {
      font-size: 23px;
      line-height: 32px;
      color: #004466;
      text-align: left;
      @media (max-width: 400px) {
        font-size: 20px;
      }
    }
  }
}

.homequote {
  text-align: center;
  font-size: 24px;
  line-height: 32px;
  font-style: italic;
  color: #666;
  max-width: 600px;
  margin: 20px auto;
}

.inlinebubble3 {
  color:#fff;
  border:10px solid #f3bc45;
  background:#000 url("~@/assets/simmitri-logo.png") no-repeat 50% 50%;
  background-size:80%;
  padding:40px;
  border-radius:50%;
  width:370px;
  height:370px;
  text-align:center;
  margin: 10px auto;
  @media (max-width: 415px) {
    border:4px solid #f3bc45;
    padding:20px 10px;
    // border-radius:0%;
    width:300px;
    height:300px;
  }
}

#tbl_challenges {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  & .col_challenges {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
    padding: 10px;
    min-width: 200px;
    & h3 {
      font-size: 24px;
      line-height: 32px;
      color: #000;
      text-align: left;
      background: #efefef;
      padding: 10px;
      border-bottom: 1px solid #ccc;
      @media (max-width: 400px) {
        font-size: 20px;
      }
    }
    & .itm_challenges {
      font-size: 18px;
      line-height: 28px;
      color: #666;
      text-align: left;
      margin: 10px 0;
      @media (max-width: 400px) {
        font-size: 16px;
      }
    }
  }
}

.pink-links a {
  color: #BF00FF;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
}
.pink-links a:hover {
  color: #7a4fa3;
  text-decoration: underline;
}
</style>

